import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    dark: 'bg-[#2D3748] text-white'
  };
  return <section id={id} className={`py-16 lg:py-24 ${bgColors[background]} ${className}`} data-id="element-208">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-209">{children}</div>
    </section>;
}